
export default function checkUserActiveChat(chat, authUserId ){
    const data = chat.find( item => {
        return item.user && item.user.id == authUserId;
    });

    return data;
}